import Oidc from 'oidc-client';
import { addNotification } from '../api-utilities/notification-tools';
import { saveAuth, clearAuth, syncAuthToRedux, clearAuthRedux } from './authStorage';

//This is intentionally the ONLY file in the app that talks to oidc-client/UserManager.
//It's used for exactly two things: kicking off login (signinRedirect), and processing the
//two redirects IdentityServer sends back (signinRedirectCallback on /login,
//signoutRedirectCallback on /logout). The moment a login callback completes, we pull out
//access_token/expires_at/profile and hand them to authStorage.ts, which owns our own
//localStorage entry from then on. Nothing else in the app should import oidc-client directly.

const settings = {
  authority: process.env.REACT_APP_IDENTITY_AUTHORITY,
  client_id: process.env.REACT_APP_IDENTITY_CLIENTID,
  redirect_uri: process.env.REACT_APP_IDENTITY_LOGINREDIRECT,
  post_logout_redirect_uri: process.env.REACT_APP_IDENTITY_LOGOUTREDIRECT,
  response_type: 'id_token token',
  scope: `openid profile ${process.env.REACT_APP_IDENTITY_LOWRYAPISCOPE}`,
  revokeAccessTokenOnSignout: true
};
const userMgr = new Oidc.UserManager(settings);

function handleError(error: any) {
  console.log('Problem with authentication endpoint: ', error);
  const notification = {
    id: 'authenticationError',
    notificationType: 'error',
    title: 'Error',
    content: error.toString()
  };
  addNotification(notification);
}

export async function login() {
  await userMgr.clearStaleState();
  await userMgr.signinRedirect().catch((error: any) => handleError(error));
}

//Called only from the /login page (IdentityLogin.tsx), which is the OIDC redirect_uri.
export async function completeLogin() {
  try {
    const user = await userMgr.signinRedirectCallback();
    saveAuth(user.access_token, user.expires_at, user.profile);
    syncAuthToRedux();
    return user;
  } catch (err) {
    return null;
  }
}

export async function logout() {
  clearAuth();
  clearAuthRedux();
  await userMgr.signoutRedirect().catch((error: any) => handleError(error));
  await userMgr.clearStaleState();
}

//Called only from the /logout page (IdentityLogout.tsx), which is the OIDC post_logout_redirect_uri.
export async function completeLogout() {
  await userMgr.signoutRedirectCallback().catch((error: any) => handleError(error));
  clearAuth();
}
